export enum EditableStudyMaterialTypeEnum {
	Course = 'Course',
	Quiz = 'Quiz'
}
